import type {
  ProjectInfo,
  LegalDoc,
  EligibilityGroup,
  Condition,
  ProcessStep,
  RequiredDoc,
  AnnouncementItem,
  ProgressPhase,
  FAQ,
  ApartmentType,
  TimelineItem,
  UpdateLog,
} from '@/lib/index';

export const projectInfo: ProjectInfo = {
  name: 'Xây Dựng Nhà Ở Cho Lực Lượng Vũ Trang CAND Tại Xuân Phương',
  shortName: 'HARMONY Xuân Phương',
  address: 'Ô đất OCT1, OCT3 Khu Chức Năng Đô Thị Xuân Phương',
  district: 'Phường Xuân Phương, Quận Nam Từ Liêm',
  city: 'TP. Hà Nội',
  investor:
    'Công ty Cổ phần Đầu tư Vietasset và Công ty Cổ phần Đầu tư và Xây lắp Constrexim Số 8 (Đại diện nhà đầu tư liên danh: Công ty Cổ phần Đầu tư Vietasset)',
  towers: [
    {
      name: 'OCT1',
      floors: 25,
      basements: 3,
      landArea: 3185,
      constructionArea: 1510,
      constructionDensity: 47.4,
      totalFloorArea: 39081,
      landUsageCoefficient: 9.4,
      totalUnits: 240,
      population: 680,
    },
    {
      name: 'OCT3',
      floors: 25,
      basements: 3,
      landArea: 7836,
      constructionArea: 3558,
      constructionDensity: 45.4,
      totalFloorArea: 91262,
      landUsageCoefficient: 8.8,
      totalUnits: 578,
      population: 1657,
    },
  ],
  totalUnits: 818,
  areaRange: {
    min: 25,
    max: 70,
  },
  pricePerSqm: 25000000,
  startDate: 'Quý II/2025',
  expectedHandover: 'Quý III/2028',
  description:
    'HARMONY Xuân Phương là dự án xây dựng nhà ở xã hội cho Lực lượng vũ trang Công an nhân dân (LLVT CAND) tại các ô đất OCT1, OCT3 – Khu Chức Năng Đô Thị Xuân Phương, Phường Xuân Phương, Quận Nam Từ Liêm, TP. Hà Nội. Do liên danh Công ty CP Đầu tư Vietasset và Constrexim Số 8 làm chủ đầu tư, dự án gồm 2 khối nhà 25 tầng nổi và 3 tầng hầm với tổng cộng 818 căn hộ. Đây là dự án nhà ở xã hội quy mô lớn, phục vụ nhu cầu an cư cho cán bộ chiến sĩ CAND và các đối tượng ưu tiên theo Luật Nhà ở 2023.',
  features: [
    '2 khối nhà HARMONY OCT1 & OCT3 cao 25 tầng nổi + 3 tầng hầm hiện đại',
    'Tổng 818 căn hộ (OCT1: 240 căn, OCT3: 578 căn)',
    'Tổng diện tích sàn xây dựng hơn 130.000 m²',
    'Tầng hầm để xe đủ chỗ cho 2.337 cư dân (OCT1: 680, OCT3: 1.657)',
    'Hệ thống tiện ích nội khu hiện đại phục vụ Lực lượng CAND và gia đình',
    'Khu thương mại dịch vụ tầng 1 phục vụ nhu cầu sinh hoạt',
    'Thiết kế căn hộ khép kín theo tiêu chuẩn nhà ở xã hội Luật Nhà ở 2023',
  ],
  infrastructure: [
    'Nhà ga tuyến Metro số 7 – chỉ 2 phút đi bộ',
    'Thiên đường Bảo Sơn – 5 phút',
    'SVĐ Quốc gia Mỹ Đình – 8 phút',
    'Keangnam Landmark Tower – 10 phút',
    'Trường quốc tế ST. Paul American, Vinschool, Hà Nội Amsterdam – 2-15 phút',
    'TT Hội nghị Quốc gia, Bộ Ngoại giao – 5-10 phút',
    'TTTM Aeon Mall Hà Đông, Big C, Vincom Mega Mall, The Garden – 5-10 phút',
    'Sân bay Nội Bài – 40 phút',
    'Các KĐT lân cận: Vinhomes Smart City, Vinhomes Gardenia, KĐT Splendora – 5-10 phút',
  ],
};

export const legalDocs: LegalDoc[] = [
  {
    id: 'legal-1',
    name: 'Quyết định chấp thuận chủ trương đầu tư dự án nhà ở CAND tại Xuân Phương',
    status: 'Đã ban hành',
    date: '2024',
    issuingAuthority: 'UBND TP. Hà Nội',
    documentNumber: 'QĐ-UBND/HN',
    downloadUrl: '#',
  },
  {
    id: 'legal-2',
    name: 'Giấy phép xây dựng tòa OCT1 – Khu Chức Năng Đô Thị Xuân Phương',
    status: 'Đã ban hành',
    date: '2025',
    issuingAuthority: 'Sở Xây dựng TP. Hà Nội',
    documentNumber: 'GPXD-SXD/HN',
    downloadUrl: '#',
  },
  {
    id: 'legal-3',
    name: 'Giấy phép xây dựng tòa OCT3 – Khu Chức Năng Đô Thị Xuân Phương',
    status: 'Đã ban hành',
    date: '2025',
    issuingAuthority: 'Sở Xây dựng TP. Hà Nội',
    documentNumber: 'GPXD-SXD/HN',
    downloadUrl: '#',
  },
  {
    id: 'legal-4',
    name: 'Biên bản thẩm định thiết kế cơ sở dự án',
    status: 'Đã ban hành',
    date: '2025',
    issuingAuthority: 'Sở Xây dựng TP. Hà Nội',
    documentNumber: 'BB-SXD/HN',
    downloadUrl: '#',
  },
  {
    id: 'legal-5',
    name: 'Quyết định giao đất ô OCT1 và OCT3 Xuân Phương',
    status: 'Đã ban hành',
    date: '2024',
    issuingAuthority: 'UBND Phường Xuân Phương / TP. Hà Nội',
    documentNumber: 'QĐ-UBND/XP',
    downloadUrl: '#',
  },
  {
    id: 'legal-6',
    name: 'Phê duyệt quy hoạch 1/500 Khu Đô Thị Xuân Phương',
    status: 'Đã ban hành',
    date: '2024',
    issuingAuthority: 'Sở Quy hoạch – Kiến trúc TP. Hà Nội',
    documentNumber: 'QH-SQHKT/HN',
    downloadUrl: '#',
  },
  {
    id: 'legal-7',
    name: 'Hợp đồng liên danh đầu tư Vietasset – Constrexim Số 8',
    status: 'Đã ban hành',
    date: '2024',
    issuingAuthority: 'Công ty CP Đầu tư Vietasset',
    documentNumber: 'HĐLK-VIETASSET',
    downloadUrl: '#',
  },
];

// 9 nhóm đối tượng theo Điều 76 Luật Nhà ở 2023 – căn cứ từ cẩm nang HARMONY Xuân Phương
export const eligibilityGroups: EligibilityGroup[] = [
  {
    id: 'group-1',
    groupNumber: 1,
    name: 'Người có công với cách mạng',
    description:
      'Người có công với cách mạng, thân nhân liệt sĩ thuộc trường hợp được hỗ trợ cải thiện nhà ở theo quy định của Pháp lệnh Ưu đãi người có công với cách mạng (Khoản 1 – Điều 76 Luật Nhà ở 2023).',
    isMainGroup: true,
  },
  {
    id: 'group-4',
    groupNumber: 4,
    name: 'Hộ gia đình nghèo, cận nghèo đô thị',
    description:
      'Hộ gia đình nghèo, cận nghèo tại khu vực đô thị (Khoản 4 Điều 76 Luật Nhà ở 2023).',
    isMainGroup: true,
  },
  {
    id: 'group-5',
    groupNumber: 5,
    name: 'Người có thu nhập thấp tại khu vực đô thị',
    description:
      'Người có thu nhập thấp tại khu vực đô thị (Khoản 5 – Điều 76 Luật Nhà ở 2023).',
    isMainGroup: true,
  },
  {
    id: 'group-6',
    groupNumber: 6,
    name: 'Công nhân, người lao động khu công nghiệp',
    description:
      'Công nhân, người lao động đang làm việc tại doanh nghiệp, hợp tác xã, liên hiệp hợp tác xã trong và ngoài khu công nghiệp (Khoản 6 – Điều 76 Luật Nhà ở 2023).',
    isMainGroup: true,
  },
  {
    id: 'group-7',
    groupNumber: 7,
    name: 'Lực lượng vũ trang nhân dân (LLVTND)',
    description:
      'Sĩ quan, quân nhân chuyên nghiệp, hạ sĩ quan thuộc lực lượng vũ trang nhân dân, công nhân công an, công chức, công nhân và viên chức quốc phòng đang phục vụ tại ngũ; người làm công tác cơ yếu, người làm công tác khác trong tổ chức cơ yếu hưởng lương từ ngân sách nhà nước đang công tác (Khoản 7 Điều 76 Luật Nhà ở 2023).',
    isMainGroup: true,
  },
  {
    id: 'group-8',
    groupNumber: 8,
    name: 'Cán bộ, công chức, viên chức',
    description:
      'Cán bộ, công chức, viên chức theo quy định của pháp luật về cán bộ, công chức, viên chức (Khoản 8 Điều 76 Luật Nhà ở 2023).',
    isMainGroup: true,
  },
  {
    id: 'group-9',
    groupNumber: 9,
    name: 'Người đã trả lại nhà ở công vụ',
    description:
      'Đối tượng đã trả lại nhà ở công vụ theo quy định tại Khoản 4 Điều 125 của Luật Nhà ở 2023, trừ trường hợp bị thu hồi nhà ở công vụ do vi phạm quy định của Luật này (Khoản 9 Điều 76 Luật Nhà ở 2023).',
  },
  {
    id: 'group-10',
    groupNumber: 10,
    name: 'Hộ bị thu hồi đất, giải tỏa nhà ở',
    description:
      'Hộ gia đình, cá nhân thuộc trường hợp bị thu hồi đất và phải giải tỏa, phá dỡ nhà ở theo quy định của pháp luật mà chưa được Nhà nước bồi thường bằng nhà ở, đất ở (Khoản 10 Điều 76 Luật Nhà ở 2023).',
  },
  {
    id: 'group-11',
    groupNumber: 11,
    name: 'Học sinh, sinh viên (chỉ được thuê)',
    description:
      'Học sinh, sinh viên (chỉ được thuê, không được mua) (Khoản 11 Điều 76 Luật Nhà ở 2023).',
  },
];

export const conditions: Condition[] = [
  {
    id: 'condition-1',
    title: 'Điều kiện 01 – Về đối tượng',
    description:
      'Thuộc 1 trong 9 đối tượng quy định tại Điều 76 Luật Nhà ở 2023. Hình thức: Mua NOXH phải đáp ứng điều kiện về nhà ở và thu nhập.',
    requirements: [
      'Thuộc 1 trong 9 đối tượng quy định tại Điều 76 Luật Nhà ở 2023',
      'Mua NOXH: phải đáp ứng đồng thời điều kiện về nhà ở và thu nhập',
    ],
  },
  {
    id: 'condition-2',
    title: 'Điều kiện 02 – Về thu nhập',
    description:
      'Điều kiện thu nhập áp dụng theo từng nhóm đối tượng cụ thể:',
    requirements: [
      'Người có công (Khoản 1 Điều 76): không quy định điều kiện thu nhập',
      'Hộ nghèo, cận nghèo (Khoản 2, 3, 4 Điều 76): theo chuẩn nghèo của Chính phủ',
      'Đối tượng TNT, CN, CBCC (Khoản 5, 6, 8 Điều 76) – Độc thân: thu nhập hàng tháng ≤ 15 triệu đồng',
      'Đối tượng TNT, CN, CBCC (Khoản 5, 6, 8 Điều 76) – Đã kết hôn: tổng thu nhập 2 vợ chồng ≤ 30 triệu đồng',
      'Đối tượng TNT (Khoản 5 Điều 76) không có HĐLĐ, UBND cấp xã thực hiện xác nhận',
      'Đối tượng LLVTND (Khoản 7 Điều 76) – Người độc thân: thu nhập hàng tháng ≤ tổng thu nhập của sĩ quan có cấp bậc hàm Đại tá',
      'Đối tượng LLVTND – Vợ chồng đều thuộc LLVTND: thu nhập hàng tháng ≤ 2 lần tổng thu nhập của sĩ quan có cấp bậc hàm Đại tá',
      'Đối tượng LLVTND – Vợ/chồng không thuộc LLVTND: thu nhập hàng tháng ≤ 1,5 lần tổng thu nhập của sĩ quan có cấp bậc hàm Đại tá',
    ],
  },
  {
    id: 'condition-3',
    title: 'Điều kiện 03 – Về nhà ở',
    description:
      'Người mua NOXH phải đáp ứng một trong các điều kiện về nhà ở sau:',
    requirements: [
      'Trường hợp chưa có nhà ở thuộc sở hữu: đối tượng và vợ/chồng (nếu có) không có tên trong Giấy chứng nhận quyền sử dụng đất, quyền sở hữu tài sản gắn liền với đất trên địa bàn tỉnh Bắc Giang tại thời điểm nộp hồ sơ đăng ký',
      'Trường hợp có nhà ở: diện tích bình quân < 15 m² sàn/người',
      'Chưa được hưởng chính sách về nhà ở xã hội (NOXH)',
    ],
  },
];

export const processSteps: ProcessStep[] = [
  {
    id: 'step-1',
    stepNumber: 1,
    title: 'Tư vấn tiếp nhận hồ sơ mua NOXH',
    description:
      'Tiếp nhận tư vấn và nộp hồ sơ mua NOXH HARMONY Xuân Phương. Địa điểm tiếp nhận: Tầng 5, tòa CT1 The Pride Tố Hữu, Hà Đông, Hà Nội. Hotline: 0917978466.',
    duration: 'Quý I/2026',
  },
  {
    id: 'step-2',
    stepNumber: 2,
    title: 'Tiếp nhận, xét duyệt hồ sơ và ký hợp đồng',
    description:
      'Chủ đầu tư tiếp nhận hồ sơ, xét duyệt điều kiện và ký hợp đồng mua nhà ở xã hội với người đủ điều kiện.',
    duration: 'Dự kiến Quý II/2026',
  },
  {
    id: 'step-3',
    stepNumber: 3,
    title: 'Bàn giao căn hộ',
    description:
      'Bàn giao căn hộ cho cư dân sau khi hoàn thiện công trình và nghiệm thu. Dự kiến bàn giao Quý III/2028.',
    duration: 'Dự kiến Quý III/2028',
  },
  {
    id: 'step-4',
    stepNumber: 4,
    title: 'Cấp Giấy chứng nhận quyền sử dụng đất',
    description:
      'Làm thủ tục cấp Giấy chứng nhận quyền sử dụng đất và quyền sở hữu nhà ở (sổ hồng) cho cư dân.',
    duration: 'Dự kiến Quý I/2029',
  },
];

export const requiredDocs: RequiredDoc[] = [
  {
    id: 'doc-1',
    name: 'Đơn đề nghị mua nhà ở xã hội',
    description: 'Theo mẫu của Bộ Xây dựng, có chữ ký xác nhận. Tải biểu mẫu chi tiết qua QR code tại văn phòng dự án hoặc hotline 0917978466.',
    required: true,
  },
  {
    id: 'doc-2',
    name: 'CCCD/CMND hoặc VNeID',
    description: 'Bản sao có công chứng hoặc xác thực qua VNeID',
    required: true,
  },
  {
    id: 'doc-3',
    name: 'Giấy xác nhận thu nhập',
    description:
      'Bảng lương 12 tháng gần nhất, hợp đồng lao động; đối với LLVTND: xác nhận lương theo cấp bậc hàm từ đơn vị công tác',
    required: true,
  },
  {
    id: 'doc-4',
    name: 'Giấy xác nhận điều kiện nhà ở',
    description:
      'Xác nhận chưa có nhà hoặc diện tích nhà hiện tại dưới 15m²/người. Xác nhận chưa được hưởng chính sách NOXH.',
    required: true,
  },
  {
    id: 'doc-5',
    name: 'Giấy tờ cư trú / Đăng ký thường trú hoặc tạm trú',
    description: 'Sổ hộ khẩu thường trú hoặc giấy xác nhận tạm trú tại Hà Nội',
    required: true,
  },
  {
    id: 'doc-6',
    name: 'Giấy tờ chứng minh đối tượng LLVTND',
    description:
      'Đối với Lực lượng vũ trang CAND: Quyết định phong hàm, thẻ sĩ quan/chiến sĩ, xác nhận của đơn vị công tác; đối với CBCC: quyết định tuyển dụng, thẻ công chức viên chức',
    required: true,
  },
  {
    id: 'doc-7',
    name: 'Giấy kết hôn (nếu có)',
    description: 'Bản sao có công chứng, áp dụng cho hộ gia đình có vợ/chồng',
    required: false,
  },
  {
    id: 'doc-8',
    name: 'Các biểu mẫu kê khai theo hướng dẫn',
    description:
      'Tải bộ hồ sơ chi tiết gồm 03 thành phần và các biểu mẫu kê khai bằng cách quét mã QR tại văn phòng dự án hoặc liên hệ hotline 0917978466',
    required: true,
  },
];

export const announcements: AnnouncementItem[] = [
  {
    id: 'announce-1',
    title: 'Chính thức tiếp nhận hồ sơ mua NOXH HARMONY Xuân Phương – Quý I/2026',
    category: 'Thông báo dự án',
    date: 'QI/2026',
    summary:
      'Từ Quý I/2026, Công ty CP Đầu tư Vietasset chính thức tư vấn và tiếp nhận hồ sơ mua nhà ở xã hội HARMONY Xuân Phương. Địa điểm: Tầng 5, tòa CT1 The Pride Tố Hữu, Hà Đông, Hà Nội. Hotline: 0917978466.',
    content:
      'Văn phòng giao dịch dự án cung cấp dịch vụ tư vấn "2 trong 1": tư vấn nhà ở và tư vấn tài chính ngân hàng (Vietcombank, MB Bank, Ngân hàng UBSP). Quý khách vui lòng quét mã QR để tải bộ hồ sơ chi tiết và các biểu mẫu kê khai.',
  },
  {
    id: 'announce-2',
    title: 'Hỗ trợ tài chính: Vay ưu đãi mua NOXH HARMONY Xuân Phương',
    category: 'Giá bán',
    date: 'QI/2026',
    summary:
      'Chủ đầu tư Vietasset ký kết hợp tác với 3 ngân hàng lớn để hỗ trợ tài chính cho người mua: Ngân hàng UBSP (lãi suất 6,6%/năm), Vietcombank (6,1%/năm – cố định 5 năm), MB Bank (6,6%/năm – cố định 10 năm). Mức vay tối đa 70-80% giá trị căn hộ, lên đến 1 tỷ đồng, thời hạn vay lên đến 25 năm.',
    content:
      'Chi tiết các gói vay:\n• Ngân hàng UBSP: lãi suất ưu đãi 6,6%/năm, lãi suất nợ quá hạn 130%, vay tối đa 80% giá trị (lên đến 1 tỷ đồng), thời gian vay lên đến 25 năm.\n• Vietcombank: lãi suất ưu đãi 6,1%/năm (cố định 5 năm), vay tối đa 70% giá trị (lên đến 1 tỷ đồng), thời gian vay lên đến 25 năm.\n• MB Bank: lãi suất ưu đãi 6,6%/năm (cố định 10 năm), vay tối đa 70% giá trị (lên đến 1 tỷ đồng), thời gian vay lên đến 25 năm.',
  },
  {
    id: 'announce-3',
    title: 'Quy trình mua NOXH HARMONY Xuân Phương 4 bước',
    category: 'Hồ sơ',
    date: 'QI/2026',
    summary:
      '4 bước: (1) Tư vấn tiếp nhận hồ sơ (QI/2026) → (2) Xét duyệt & ký hợp đồng (QIII/2026) → (3) Bàn giao căn hộ (QIII/2028) → (4) Cấp GCN quyền sử dụng đất (QI/2029). Địa chỉ tiếp nhận: Tầng 5, tòa CT1 The Pride Tố Hữu, Hà Đông, Hà Nội.',
    content:
      'Trình tự mua NOXH và thời gian dự kiến:\n1. Tư vấn tiếp nhận hồ sơ mua NOXH: Quý I/2026\n2. Tiếp nhận, xét duyệt hồ sơ và ký hợp đồng: Dự kiến Quý II/2026\n3. Bàn giao căn hộ: Dự kiến Quý III/2028\n4. Cấp Giấy chứng nhận quyền sử dụng đất: Quý I/2029',
  },
  {
    id: 'announce-4',
    title: 'Thông tin quy mô dự án: OCT1 (240 căn) và OCT3 (578 căn)',
    category: 'Thông tin dự án',
    date: '2025',
    summary:
      'OCT1: DT khu đất 3.185m², DT xây dựng 1.510m², mật độ 47,4%, tổng DT sàn 39.081m², 240 căn hộ, 680 cư dân. OCT3: 7.836m², 3.558m², 45,4%, 91.262m², 578 căn hộ, 1.657 cư dân. Tổng: 818 căn hộ, 2.337 cư dân.',
    content:
      'Thông số kỹ thuật chi tiết: OCT1 – Hệ số sử dụng đất: 9,4 lần; OCT3 – Hệ số sử dụng đất: 8,8 lần. Cả hai khối đều có 3 tầng hầm để xe. Chủ đầu tư: Công ty CP Đầu tư Vietasset (đại diện liên danh với Constrexim Số 8).',
  },
  {
    id: 'announce-5',
    title: 'Bản đồ vị trí & Liên kết vùng – HARMONY Xuân Phương',
    category: 'Thông tin dự án',
    date: '2025',
    summary:
      'Vị trí đắc địa tại Xuân Phương, Nam Từ Liêm: cách nhà ga Metro số 7 chỉ 2 phút, Thiên đường Bảo Sơn 5 phút, SVĐ Quốc gia Mỹ Đình 8 phút, Keangnam 10 phút, sân bay Nội Bài 40 phút.',
    content:
      'Liên kết vùng nổi bật:\n• Sân bay Nội Bài: 40 phút\n• Nhà ga Metro số 7: 2 phút\n• Thiên đường Bảo Sơn: 5 phút\n• Trường quốc tế & Đại học (ST. Paul American, Vinschool, HN-Amsterdam, ĐH Thương mại): 2-15 phút\n• SVĐ Quốc gia Mỹ Đình: 8 phút\n• Keangnam: 10 phút\n• TT Hội nghị Quốc gia, Bộ Ngoại giao: 5-10 phút\n• TTTM Aeon Mall HĐ, Big C, Vincom Mega Mall, The Garden: 5-10 phút\n• Vinhomes Smart City, Vinhomes Gardenia, KĐT Splendora: 5-10 phút',
  },
];

export const progressPhases: ProgressPhase[] = [
  {
    id: 'phase-1',
    phaseNumber: 1,
    name: 'San lấp mặt bằng & Đào móng',
    status: 'Hoàn thành',
    startDate: 'QII/2025',
    endDate: 'QIII/2025',
    completionPercentage: 100,
    description:
      'Hoàn thành công tác giải phóng mặt bằng, san lấp và đào móng cho cả 2 khối nhà OCT1 (diện tích đất 3.185m²) và OCT3 (diện tích đất 7.836m²).',
  },
  {
    id: 'phase-2',
    phaseNumber: 2,
    name: 'Thi công phần ngầm (3 tầng hầm)',
    status: 'Hoàn thành',
    startDate: 'QIII/2025',
    endDate: 'QIV/2025',
    completionPercentage: 100,
    description:
      'Hoàn thành thi công 3 tầng hầm (để xe + kỹ thuật) cho cả 2 khối nhà OCT1 và OCT3 với tổng diện tích xây dựng 1.510m² (OCT1) và 3.558m² (OCT3).',
  },
  {
    id: 'phase-3',
    phaseNumber: 3,
    name: 'Thi công phần thân tòa OCT1 (25 tầng)',
    status: 'Đang thi công',
    startDate: 'QI/2026',
    endDate: 'QIV/2026',
    completionPercentage: 40,
    description:
      'Đang thi công phần thân tòa OCT1 từ tầng 1 đến tầng 25 nổi. Tổng diện tích sàn OCT1 là 39.081m², dự kiến 240 căn hộ phục vụ 680 cư dân.',
  },
  {
    id: 'phase-4',
    phaseNumber: 4,
    name: 'Thi công phần thân tòa OCT3 (25 tầng)',
    status: 'Chưa bắt đầu',
    startDate: 'QI/2027',
    endDate: 'QII/2027',
    completionPercentage: 0,
    description:
      'Dự kiến thi công phần thân tòa OCT3 (25 tầng nổi). Tổng diện tích sàn 91.262m², cung cấp 578 căn hộ cho 1.657 cư dân – khối lớn nhất dự án.',
  },
  {
    id: 'phase-5',
    phaseNumber: 5,
    name: 'Hoàn thiện, Nghiệm thu & Bàn giao',
    status: 'Chưa bắt đầu',
    startDate: 'QIII/2028',
    endDate: 'QIV/2028',
    completionPercentage: 0,
    description:
      'Hoàn thiện nội thất, lắp đặt hệ thống kỹ thuật, nghiệm thu toàn bộ 818 căn hộ (OCT1: 240 căn + OCT3: 578 căn) và bàn giao cho cư dân. Dự kiến cấp Giấy chứng nhận QSD đất (sổ hồng) vào Quý I/2029.',
  },
];

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: 'HARMONY Xuân Phương ưu tiên đối tượng nào mua nhà?',
    answer:
      'Dự án ưu tiên Lực lượng vũ trang nhân dân (LLVTND) – Khoản 7 Điều 76 Luật Nhà ở 2023, bao gồm sĩ quan, quân nhân chuyên nghiệp, hạ sĩ quan, công nhân công an, viên chức quốc phòng đang phục vụ tại ngũ. Ngoài ra còn có 8 nhóm đối tượng khác theo Điều 76.',
  },
  {
    id: 'faq-2',
    question: 'Điều kiện thu nhập cho LLVTND mua NOXH là bao nhiêu?',
    answer:
      'Người độc thân thuộc LLVTND: thu nhập hàng tháng ≤ tổng thu nhập của sĩ quan có cấp bậc hàm Đại tá. Vợ chồng đều thuộc LLVTND: thu nhập ≤ 2 lần thu nhập Đại tá. Vợ/chồng không thuộc LLVTND: thu nhập ≤ 1,5 lần thu nhập Đại tá.',
  },
  {
    id: 'faq-3',
    question: 'Điều kiện về nhà ở để được mua NOXH HARMONY Xuân Phương?',
    answer:
      'Có 3 trường hợp: (1) Chưa có nhà ở thuộc sở hữu: đối tượng và vợ/chồng không có tên trong Giấy chứng nhận QSD đất tại tỉnh Bắc Giang; (2) Có nhà ở nhưng diện tích bình quân < 15m²/người; (3) Chưa được hưởng chính sách NOXH.',
  },
  {
    id: 'faq-4',
    question: 'Nộp hồ sơ ở đâu và từ khi nào?',
    answer:
      'Bắt đầu từ Quý I/2026 tại Tầng 5, tòa CT1 The Pride Tố Hữu, Hà Đông, Hà Nội. Hotline tư vấn: 0917978466. Bộ hồ sơ chi tiết và biểu mẫu kê khai có thể tải về bằng cách quét mã QR tại văn phòng dự án.',
  },
  {
    id: 'faq-5',
    question: 'Có thể vay ngân hàng mua NOXH HARMONY không? Lãi suất bao nhiêu?',
    answer:
      'Có. Chủ đầu tư đã ký kết với 3 ngân hàng: (1) Ngân hàng UBSP: lãi suất 6,6%/năm, vay tối đa 80% (≤1 tỷ đồng), 25 năm; (2) Vietcombank: 6,1%/năm cố định 5 năm, tối đa 70%; (3) MB Bank: 6,6%/năm cố định 10 năm, tối đa 70%.',
  },
  {
    id: 'faq-6',
    question: 'Khi nào bàn giao căn hộ và cấp sổ hồng?',
    answer:
      'Bàn giao căn hộ dự kiến vào Quý III/2028. Cấp Giấy chứng nhận quyền sử dụng đất (sổ hồng) dự kiến vào Quý I/2029.',
  },
];

export const apartmentTypes: ApartmentType[] = [
  {
    type: 'Căn hộ 1 Phòng ngủ',
    area: '~45-50m²',
    estimatedPrice: 'Theo giá NOXH',
  },
  {
    type: 'Căn hộ 2 Phòng ngủ',
    area: '~55-65m²',
    estimatedPrice: 'Theo giá NOXH',
  },
  {
    type: 'Căn hộ 3 Phòng ngủ',
    area: '~65-70m²',
    estimatedPrice: 'Theo giá NOXH',
  },
];

export const timeline: TimelineItem[] = [
  {
    quarter: 'QII',
    year: '2025',
    milestone: 'Khởi công xây dựng dự án HARMONY Xuân Phương',
  },
  {
    quarter: 'QIII',
    year: '2025',
    milestone: 'San lấp mặt bằng, đào móng tòa OCT1 & OCT3',
  },
  {
    quarter: 'QIV',
    year: '2025',
    milestone: 'Hoàn thành thi công phần ngầm, 3 tầng hầm',
  },
  {
    quarter: 'QI',
    year: '2026',
    milestone: 'Tư vấn tiếp nhận hồ sơ mua NOXH (Tầng 5, CT1 The Pride Tố Hữu, Hà Đông)',
  },
  {
    quarter: 'QII',
    year: '2026',
    milestone: 'Xét duyệt hồ sơ & ký hợp đồng mua bán',
  },
  {
    quarter: 'QI',
    year: '2026',
    milestone: 'Thi công phần thân tòa OCT1 (25 tầng nổi)',
  },
  {
    quarter: 'QIV',
    year: '2026',
    milestone: 'Cất nóc tòa OCT1 – 240 căn hộ',
  },
  {
    quarter: 'QI',
    year: '2027',
    milestone: 'Thi công phần thân tòa OCT3 (25 tầng nổi)',
  },
  {
    quarter: 'QII',
    year: '2027',
    milestone: 'Cất nóc tòa OCT3 – 578 căn hộ',
  },
  {
    quarter: 'QIII',
    year: '2028',
    milestone: 'Hoàn thiện nội thất, nghiệm thu 818 căn hộ',
  },
  {
    quarter: 'QIII',
    year: '2028',
    milestone: 'Bàn giao căn hộ cho cư dân',
  },
  {
    quarter: 'QI',
    year: '2029',
    milestone: 'Cấp Giấy chứng nhận QSD đất (sổ hồng)',
  },
];

export const updateLogs: UpdateLog[] = [
  {
    date: 'QI/2026',
    description: 'Bắt đầu tiếp nhận hồ sơ mua NOXH tại Tầng 5, CT1 The Pride Tố Hữu, Hà Đông',
  },
  {
    date: 'QI/2026',
    description: 'Bắt đầu thi công phần thân tòa OCT1 (25 tầng nổi)',
  },
  {
    date: 'QIV/2025',
    description: 'Hoàn thành thi công 3 tầng hầm cả 2 khối OCT1 và OCT3',
  },
  {
    date: 'QIII/2025',
    description: 'Hoàn thành san lấp mặt bằng và đào móng OCT1 & OCT3',
  },
  {
    date: 'QII/2025',
    description: 'Lễ khởi công dự án HARMONY Xuân Phương – OCT1, OCT3',
  },
  {
    date: '2025',
    description: 'Hoàn thiện hồ sơ pháp lý, cấp phép xây dựng tòa OCT1 & OCT3',
  },
  {
    date: '2024',
    description: 'Quyết định chấp thuận chủ trương đầu tư được UBND TP. Hà Nội ban hành',
  },
  {
    date: '2024',
    description: 'Ký kết hợp đồng liên danh Vietasset – Constrexim Số 8',
  },
];
